import Modal from "antd/lib/modal/Modal";
import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import { Form, Input, Button, Radio, notification } from "antd";
import React, { createContext, useContext, useState } from "react";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import TextArea from "antd/lib/input/TextArea";
const _ = require("underscore");
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const SaveQueryDialog = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const clearForm = () => {
    setTitle("");
    setDescription("");
  };
  return (
    <Modal
      title="Save Query"
      visible={monthlyPerformanceStore.showSaveDialog}
      destroyOnClose={true}
      onOk={async () => {
        try {
          monthlyPerformanceStore.isSaving = true;
          const retVal = await monthlyPerformanceStore.saveQuery({
            title,
            description,
            query: monthlyPerformanceStore.sqlCommand,
          });
          monthlyPerformanceStore.savedQueryList.set(
            retVal.savedQueryId,
            retVal
          );
          notification.success({
            message: "SPARS Feedback",
            description: "query saved successfully",
          });
          monthlyPerformanceStore.showSaveDialog = false;
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: error.message,
          });
        } finally {
          monthlyPerformanceStore.isSaving = false;
          clearForm();
        }
      }}
      onCancel={() => {
        monthlyPerformanceStore.showSaveDialog = false;
        clearForm();
      }}
      okText="Save"
      okButtonProps={{
        disabled:
          title.length === 0 || monthlyPerformanceStore.sqlCommand.length === 0,
        loading: monthlyPerformanceStore.isSaving,
      }}
    >
      <Form layout="vertical">
        <Form.Item label="Query Template Title">
          <Input
            value={title}
            placeholder="Unique Query Title"
            onChange={({ target }) => {
              setTitle(target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Description">
          <TextArea
            placeholder="Query Description"
            rows={5}
            onChange={({ target }) => {
              setDescription(target.value);
            }}
            value={description}
          />
        </Form.Item>
        <Form.Item label="Query Template">
          <TextArea
            placeholder="Query"
            rows={10}
            readOnly={true}
            value={monthlyPerformanceStore.sqlCommand}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});

